<template>
  <div>
    <!-- <p class="c-inner-title">
      本地视频
      <span class="font14">
        <el-tooltip class="item" effect="dark" content="正在使用中的素材无法进行编辑、删除，如需修改请先将素材取消使用" placement="top">
          <i class="fa fa-question-circle-o gray80"></i>
        </el-tooltip>
      </span>
    </p> -->
    <div class="auto">
      <page-title title="本地视频" icon="fa-wechat" tooltip="正在使用中的素材无法进行编辑、删除，如需修改请先将素材取消使用"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" size="small" @click="AddPicHandle()">添加视频</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-input v-model="filter.search" size="small" clearable class="m-lr-5" style="width:200px;" placeholder="请输入关键字"><i class="el-icon-search el-input__icon" slot="suffix"></i></el-input>
              <el-button type="primary" size="small" @click="handleChangeFilter()">搜索</el-button>
            </el-col>
          </el-row>
          <el-table :data="tableData" style="width: 100%" v-loading="loading" size="small">
            <el-table-column label="名称">
              <template slot-scope="scope">
                <a :href="scope.row.content.url" target="_blank" class="videotitle">{{scope.row.content.title}}</a>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="简介"></el-table-column>
            <el-table-column prop="create_time" label="创建时间"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="testHandle(scope.row)">测试</el-button>
                <el-button type="text" @click="deleteHandle(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="count > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="添加视频" :modal-append-to-body="false" @close="closeDialog" :visible="dialogAdd">
      <el-form v-loading="dialogLoading" :model="file" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="视频标题" prop="title">
          <el-input v-model="file.title" placeholder="请填写视频标题"></el-input>
        </el-form-item>
        <el-form-item label="视频简介" prop="description">
          <el-input type="textarea" v-model="file.description" placeholder="请填写视频简介"></el-input>
        </el-form-item>
        <el-form-item label="视频" prop="media_id">
          <input type="hidden" v-model="file.media_id">
          <p v-if="file.media_id"><a :href="file.media_url" target="_blank" class="blue">{{file.media_title}}</a><a href="javascript:;" class="blue" @click="openMaterial('video')" style="margin-left: 20px;">更改</a></p>
          <el-button v-else size="small" type="primary" @click="openMaterial('video')">选择视频</el-button>
        </el-form-item>
        <el-form-item label="视频封面" prop="thumb_media_id">
          <div class="avatar" @click="openMaterial('image')">
            <img v-if="file.url" :src="file.url">
            <p v-else><i class="el-icon-plus avatar-uploader-icon"></i></p>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitFn('ruleForm')" :loading="uploadLoading">确定</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="选择素材" :modal-append-to-body="false" :visible.sync="materialVisible" width="70%">
      <div style="width:100%;height:auto;overflow:hidden;margin-bottom: 20px;">
        <div style="width:200px;float:right;">
          <el-input v-model="materialkeywords" size="small" placeholder="请输入关键字"><i class="el-icon-search el-input__icon" slot="suffix"></i></el-input>
        </div>
        <div style="float:right;margin-right:10px;">
          <dates-picker v-model="date" size="small"></dates-picker>
        </div>
      </div>
      <div class="dialogBox masonry" v-if="materialType === 'image'" v-loading="materialLoading">
        <div class="list-box" :class="item.choose ? 'list-box-cur' : ''" v-for="(item, index) in materialArr" :key="index">
          <div>
            <div class="listbox-top">
              <div class="hasposterBox">
                <dl class="hasposter">
                  <dt>{{item.title}}</dt>
                  <dd><img :src="item.url" alt=""></dd>
                </dl>
              </div>
            </div>
          </div>
          <div class="dialogControl">
            <span v-if="item.remark" style="float: left;">
              <el-tooltip class="tip-item" effect="dark" placement="top">
                <div slot="content">{{item.remark}}</div>
                <i class="el-icon-question" small></i>
              </el-tooltip>
            </span>
            <a href="javascript:;" class="alink" style="float: right;" @click="chooseMaterial(index)">选择</a>
          </div>
        </div>
      </div>
      <div class="dialogBox" v-else>
        <el-table :data="materialVideoArr" style="width: 100%" v-loading="loading" size="small">
          <el-table-column label="名称">
            <template slot-scope="scope">
              <a :href="scope.row.url" target="_blank" class="videotitle">{{scope.row.title}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="chooseMaterial(scope.$index)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog title="测试" :modal-append-to-body="false" :visible.sync="testVisible" @close="handleTestClose" width="600px">
      <el-form ref="testText" :rules="testrules" :model="test" label-width="90px" size="small" v-loading="btnLoading">
        <el-form-item prop="openid" label="openid">
          <el-input type="text" v-model.trim="test.openid" placeholder="请输入测试用户的openid"></el-input>
        </el-form-item>
        <el-form-item prop="" label="">
          <p class="font12 gray80" style="line-height: 20px;">tips:测试用户的openid可以在 "用户"=>"详情" 中搜索微信昵称等方式获取,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;测试用户必须48小时内与公众号产生过互动(如发送消息、点击自定义菜单等)</p>
        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button type="primary" @click="handleTest">确定</el-button>
        <el-button @click="handleTestClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Mp } from '@/model'
export default {
  data () {
    return {
      date: [],
      materialType: 'image',
      materialArr: [],
      materialVideoArr: [],
      materialVisible: false,
      materialLoading: false,
      tableData: [],
      loading: false,
      dialogLoading: false,
      uploadLoading: false,
      changeName: '',
      dialogAdd: false,
      file: {
        title: '',
        media_id: '',
        thumb_media_id: '',
        description: '',
        url: '',
        media_title: '',
        media_url: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入视频名称', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入视频简介', trigger: 'blur' }
        ],
        media_id: [
          { required: true, message: '请选择视频', trigger: 'blur' }
        ],
        thumb_media_id: [
          { required: true, message: '请选择视频封面', trigger: 'blur' }
        ]
      },
      filter: {
        type: 'video',
        search: '',
        page: '1',
        limit: '10'
      },
      count: 0,
      materialkeywords: '',
      testVisible: false,
      test: {
        openid: '',
        type: '',
        id: ''
      },
      testrules: {
        openid: [
          { required: true, message: 'openid不能为空！', trigger: 'blur' }
        ]
      },
      btnLoading: false
    }
  },
  watch: {
    '$route': function (val) {
      this.queryToFilter()
    },
    'materialType': function (val) {
      this.date = []
      this.materialkeywords = ''
    },
    'materialkeywords': function (val) {
      this.materialSearchList()
    },
    'date': function (val) {
      this.materialSearchList()
    }
  },
  methods: {
    handleTest () {
      this.$refs['testText'].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true
          let res = await Mp.Reply.previewMessage(this.test)
          if (res && !res['err_code']) {
            this.$message.success('测试信息已发出，请注意查收！')
          } else {
            this.$message.error(res.err_msg)
          }
          this.btnLoading = false
        }
      })
    },
    handleTestClose () {
      this.test = {
        id: '',
        openid: '',
        type: ''
      }
      this.testVisible = false
    },
    testHandle (item) {
      this.test = {
        id: item.id,
        openid: '',
        type: item.type
      }
      this.testVisible = true
    },
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        type: 'video',
        search: '',
        page: '1',
        limit: '10'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/reply/video', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    AddPicHandle () {
      this.file = {
        title: '',
        media_id: '',
        thumb_media_id: '',
        description: '',
        url: '',
        media_title: '',
        media_url: ''
      }
      this.dialogAdd = true
    },
    deleteHandle (index) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteFn(this.tableData[index].id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    async deleteFn (mediaId) {
      let res = await Mp.Reply.delLocalMaterial({type: this.filter.type, id: mediaId})
      if (res.err_code !== 0) {
        this.$message.error(res.err_msg)
      } else {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getList()
      }
    },
    closeDialog () {
      this.dialogAdd = false
      this.$refs['ruleForm'].resetFields()
    },
    async getList () {
      this.loading = true
      let res = await Mp.Reply.getMaterialLocalList(this.filter)
      this.tableData = res['data']['list']
      this.count = res['data']['count']
      this.loading = false
    },
    submitFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.uploadFn()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async uploadFn () {
      this.dialogLoading = true
      let res = await Mp.Reply.saveLocalMaterialInfo({
        type: this.filter.type,
        content: {
          title: this.file.title,
          description: this.file.description,
          media_id: this.file.media_id,
          thumb_media_id: this.file.thumb_media_id
        },
        remark: this.file.description
      })
      if (res.err_code !== 0) {
        this.$message.error(res.err_msg)
      } else {
        this.dialogAdd = false
        this.$message.success('添加成功')
        this.resetFilter()
        this.getList()
      }
      this.dialogLoading = false
    },
    async getMaterial (type) {
      let mpresimage = await Mp.System.getMaterialMediaList({type: 'image'}) // 获取Mp素材信息列表
      mpresimage['data'].map((item, index) => {
        this.materialArr.push(item)
      })
      let mpresvideo = await Mp.System.getMaterialMediaList({type: 'video'}) // 获取Mp素材信息列表
      mpresvideo['data'].map((item, index) => {
        this.materialVideoArr.push(item)
      })
    },
    async materialSearchList () {
      this.materialLoading = true
      let mpres = await Mp.System.getMaterialMediaList({type: this.materialType, title: this.materialkeywords, create_time: this.date}) // 获取Mp素材信息列表
      if (this.materialType === 'image') {
        this.materialArr = []
        mpres['data'].map((item, index) => {
          this.materialArr.push(item)
        })
      } else {
        this.materialVideoArr = []
        mpres['data'].map((item, index) => {
          this.materialVideoArr.push(item)
        })
      }
      this.materialLoading = false
    },
    chooseMaterial (index) {
      var item
      if (this.materialType === 'image') {
        item = this.materialArr[index]
        this.file.url = item.url
        this.file.thumb_media_id = item.media_id
      } else {
        item = this.materialVideoArr[index]
        this.file.media_id = item.media_id
        this.file.media_title = item.title + '.' + item.type
        this.file.media_url = item.url
      }
      this.materialVisible = false
    },
    openMaterial (type) {
      this.materialType = type
      this.materialVisible = true
    }
  },
  created () {
    this.getMaterial()
    this.queryToFilter()
  }
}
</script>
<style scoped>
.imgbox{
  width: 180px;
  height: 180px;
  text-align: center;
  vertical-align: middle;
  display: -webkit-box;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.imgbox img{
  max-width: 100%;
  max-height: 100%;
  display: inline;
}
.videotitle {
  color: #409EFF;
}
.avatar {
  height: auto;
  max-height: 200px;
  overflow: hidden;
}
.avatar p {
  border: 1px dashed #ccc;
  border-radius: 5px;
}
.avatar img {
  width: 100%;
}
.masonry {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.list-box {
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0,0,0,.1);
  border-radius: 5px;
  border: 1px solid #eee;
  float: left;
  height: auto;
  overflow: hidden;
  margin: 5px 0;
}
@media (min-width: 600px) {
  .list-box {
    width: calc(30% - 22px);
    margin-right: 3%;
  }
}
@media (min-width: 1200px) {
  .list-box {
    width: calc(22% - 22px);
    margin-right: 3%;
  }
}
@media (min-width: 1600px) {
  .list-box {
    width: calc(17% - 22px);
    margin-right: 3%;
  }
}
.listbox-top {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  position: relative;
}
.listbox-top dl dt {
  font-size: 16px;
}
.noposter dd {
  color: #9a9a9a;
  font-size: 12px;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  padding-top: 10px;
}
.hasposterBox {
  position: relative;
  height: auto;
  overflow: hidden;
}
.hasposter {
  position: relative;
}
.hasposter dt {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 8px 5%;
  background: rgba(0,0,0,.55);
  color: #fff;
  width: 90%;
}
.hasposter dd {
  height: 130px;
  overflow: hidden;
}
.hasposter dd img{
  width: 100%;
  display: block;
}
</style>
